export const TOKENS = {
  NotificationSettingsService:
    '@trustedshops/tswp-core-notifications:NotificationSettingsService',
  NotificationSettingsServiceConfig:
    '@trustedshops/tswp-core-notifications:NotificationSettingsServiceConfig',
};
